import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

import TruncateText from "components/TruncateText";

import { useTranslationContext } from "context/TranslationContext";
import { getAddressPreview } from "helpers/getAddressPreview";
import cn from "lib/cn";

import { TTabeField, TTableRecord } from "../../types";
import { TAddress } from "@type/api/types";

export interface FieldAddressProps {
  field?: TTabeField;
  record?: TTableRecord;
}

const FieldAddress = ({ field, record }: FieldAddressProps) => {
  const { t } = useTranslationContext();
  const value = useMemo(() => {
    const address: TAddress = field?.key ? record?.[field.key] : undefined;
    let val = "";

    if (address?.id) {
      val = getAddressPreview({
        addresses: [address],
        postalCodeMark: t("postal_code_mark"),
      });
    }

    return val;
  }, [record, field, t]);

  return (
    <div
      className={cn([
        "text-neutral-gray-900 flex gap-3 items-center",
        field?.className,
      ])}
    >
      <TruncateText
        id={uuidv4()}
        className="flex"
        text={!value ? "-" : value}
        tooltipWidth={value?.length > 70 ? "18.75rem" : "auto"}
      />
    </div>
  );
};

export default FieldAddress;
